import { render, staticRenderFns } from "./ThreeColumnLayout.vue?vue&type=template&id=bbc09542&scoped=true&"
import script from "./ThreeColumnLayout.vue?vue&type=script&lang=js&"
export * from "./ThreeColumnLayout.vue?vue&type=script&lang=js&"
import style0 from "./ThreeColumnLayout.vue?vue&type=style&index=0&id=bbc09542&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc09542",
  null
  
)

export default component.exports